import React from "react";
import { NotifList } from "../../Components/Molecules";
import "./styles.css";

const Notifications = () => {
  return (
    <section className="panel-main">
      <div className="panel-notifications panel-card">
        <NotifList full />
      </div>
    </section>
  );
};

export default Notifications;
